<template>
  <div class="signet-h5">
    <!-- 头部导航 -->
    <Header type="h5" />
    <!-- Banner -->
    <Banner
      :isPcFlag="false"
      h5Title="专注印章风控管理"
      h5TitleSecond=" 开启智能用印时代"
      h5Desc="软硬协同，智慧办公"
      :h5BgImg="h5BgImg"
      h5signetBtn="免费试用"
      class="h5-signet-banner"
      @showSignetDialog="showSignetDialog"
      :landingPageName="landingPageName"
    />
    <!-- 表单弹框 -->
    <CoverForm :show="showForm" @close="handleClose" @msg="handleShowMsg" @submitSuccess="handleDialogFormSuccess" />
    <!-- Form提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- Form 成功弹框 -->
    <SuccessForm v-if="showSuccessDialog" @closeform="showSuccessDialog = false" :isPcFlag="false" />
    <!-- 产品介绍 -->
    <ProductIntroduction :dataList="productIntroductionList" :isPcFlag="false"></ProductIntroduction>
    <!-- 产品优势 -->
    <ProductAdvantage :dataList="productAdvantageList" :isPcFlag="false"></ProductAdvantage>
    <!-- 应用场景 -->
    <ApplicationScenarios :dataList="applicationScenariosList" :isPcFlag="false"></ApplicationScenarios>
    <!-- 系统融合 -->
    <SystemIntegration :dataList="systemIntegrationList" :isPcFlag="false"></SystemIntegration>
    <!-- 客户案例 -->
    <CustomerCase :dataList="customerCaseList" :isPcFlag="false"></CustomerCase>
    <!-- 底部 -->
    <Footer type="h5" />
  </div>
</template>

<script>
import '@/mixins/form/flexible'
import dataList from './dataList'
import pageMixin from '@/mixins/form/pageMixin.js'
export default {
  mixins: [pageMixin],
  components: {
    Header: () => import('@/components/header/index.vue'),
    Banner: () => import('@/components/Banner.vue'),
    CoverForm: () => import('@/components/CoverForm.vue'),
    Footer: () => import('@/components/footer/index.vue'),
    Message: () => import('@/components/Message.vue'),
    SuccessForm: () => import('@/components/SuccessForm.vue'),

    ProductIntroduction: () => import('./components/ProductIntroduction.vue'),
    ProductAdvantage: () => import('./components/ProductAdvantage.vue'),
    ApplicationScenarios: () => import('./components/ApplicationScenarios.vue'),
    SystemIntegration: () => import('./components/SystemIntegration.vue'),
    CustomerCase: () => import('./components/CustomerCase.vue'),
  },
  data() {
    return {
      h5BgImg: require('@/assets/images/landing-signet/h5_banner_bg.png'),
      productIntroductionList: dataList.productIntroductionList,
      productAdvantageList: dataList.productAdvantageList,
      applicationScenariosList: dataList.applicationScenariosList,
      systemIntegrationList: dataList.systemIntegrationList,
      customerCaseList: dataList.customerCaseList,
      message: {
        content: '',
        show: false,
      },
      // 成功的弹框
      showSuccessDialog: false,
      // 弹框
      showForm: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
    }
  },
  methods: {
    touchStart(event) {
      event.preventDefault() // 通知 Web 浏览器不要执行与事件关联的默认动作
    },
    showSignetDialog() {
      this.showForm = true
      document.addEventListener('touchmove', this.touchStart, { passive: false })
      // if (this.isIOS && this.isUC) {
      //   document.addEventListener('touchmove', this.touchStart, { passive: false })
      // }
    },
    handleClose() {
      this.showForm = false
      document.removeEventListener('touchmove', this.touchStart, { passive: false })
      // if (this.isIOS && this.isUC) {
      //   document.removeEventListener('touchmove', this.touchStart, { passive: false })
      // }
    },
    handleShowMsg({ content }) {
      this.message.content = content
      this.message.show = true
    },
    handleDialogFormSuccess() {
      this.handleClose()
      this.showSuccessDialog = true
    },
  },
}
</script>
<style lang="less">
.geetest_panelshowslide {
  width: 7.4133rem !important;
  height: 7.6rem !important;
  .geetest_slider_tip {
    font-size: 0.3733rem !important;
  }
  .geetest_logo {
    width: 0.2933rem !important;
    height: 0.2933rem !important;
  }
  .geetest_copyright_tip {
    font-size: 0.32rem !important;
  }
  .geetest_result {
    height: 0.7467rem !important;
    bottom: 0 !important;
  }
  .geetest_result_content {
    padding: 0.2667rem 0 !important;
    font-size: 0.3733rem !important;
  }
  .geetest_panel_success {
    padding: 1.0667rem 0 0 0 !important;
    height: 1.9467rem !important;
  }
  .geetest_panel_success_box {
    width: 0.64rem !important;
    height: 0.64rem !important;
    .geetest_panel_success_show {
      width: 0.64rem !important;
      height: 0.64rem !important;
    }
  }
  .geetest_panel_success_title {
    margin: 0.2667rem 0 0 0 !important;
  }
}
.h5-signet-banner {
  width: 100%;
  // height: 9.9467rem;
  position: relative;
  padding-top: 1.3333rem;
  .con {
    .title {
      position: absolute;
      left: 2.4533rem;
      top: 1.9733rem;
    }
    .des {
      position: absolute;
      left: 3.3333rem;
      top: 4.08rem;
    }
    .btns {
      position: absolute;
      left: 3.4133rem;
      bottom: 0.6667rem;
    }
  }
}

* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 0;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>
